
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 44 44","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"icon_heart_filled_svg__b","fill":"#fff"}},[_c('path',{attrs:{"id":"icon_heart_filled_svg__a","d":"M29.926 8.027c4.184.323 7.617 3.587 8.03 7.656a8.36 8.36 0 01-1.536 5.755l-.109.136-12.925 13.75c-.7.89-2.07.89-2.72.062L7.603 21.471l-.124-.177A8.354 8.354 0 016.053 15.6c.446-4.03 3.86-7.247 8.012-7.572 3.186-.244 6.169 1.175 7.935 3.647 1.761-2.468 4.742-3.888 7.926-3.647z"}})]),_c('use',{attrs:{"fill-rule":"nonzero","xlink:href":"#icon_heart_filled_svg__a"}}),_c('g',{attrs:{"fill":"#DB2625","mask":"url(#icon_heart_filled_svg__b)"}},[_c('path',{attrs:{"d":"M0 0h44v44H0z"}})])])])
          )
        }
      }
    